module.exports = __webpack_public_path__ + "static/media/XtadiumRoomPosterXXLNoImage.449be671.jpg";